export default __webpack_public_path__ + "static/media/character.a16a0d82.png";